var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResendInviteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.99935 6.24967C9.99935 7.86051 8.69352 9.16634 7.08268 9.16634C5.47185 9.16634 4.16602 7.86051 4.16602 6.24967C4.16602 4.63884 5.47185 3.33301 7.08268 3.33301C8.69352 3.33301 9.99935 4.63884 9.99935 6.24967Z",
    stroke: "#111827"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.9518 16.667H3.21363C2.35891 16.667 1.66602 16.0274 1.66602 15.2384C1.66602 13.266 3.39825 11.667 5.53507 11.667H8.63027C9.50127 11.667 10.3051 11.9327 10.9518 12.381",
    stroke: "#111827",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.166 11.667V16.667M16.666 14.167H11.666",
    stroke: "#111827",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResendInviteIcon);
export default __webpack_public_path__ + "static/media/resend-invite-icon.06e21ee6467d742fcd27ebb448753b5a.svg";
export { ForwardRef as ReactComponent };